import React, { useContext, useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';


export default function Login(){
  const { login, isAuthenticated } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const from = (location.state && location.state.from) || '/admin';

    useEffect(() => {
        if (!loading && isAuthenticated) {
            navigate('/', { replace: true });
        }
    }, [isAuthenticated, loading, navigate]);

  async function handleSubmit(e){
    e.preventDefault();
    setLoading(true);
    setError(null);
    const res = await login({ email, password });
    setLoading(false);
    if (res && res.error) {
      console.log('Login error response:', res);
      if (res?.details?.status === 103) {
          setError(res.details?.detail);
          return;
      }
      setError(res.error);
    } else {
      navigate(from, { replace: true });
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <form onSubmit={handleSubmit} className="w-full max-w-md bg-white p-6 rounded shadow">
        <h2 className="text-xl font-semibold mb-4">Admin Login</h2>
        {error && <div className="mb-3 text-red-600">{error}</div>}
        <label className="block mb-2 text-sm">Email</label>
        <input value={email} onChange={e=>setEmail(e.target.value)} className="w-full px-3 py-2 border rounded mb-3" />
        <label className="block mb-2 text-sm">Password</label>
        <input value={password} onChange={e=>setPassword(e.target.value)} type="password" className="w-full px-3 py-2 border rounded mb-4" />
        <div className="flex items-center justify-between">
          <button disabled={loading} className="px-4 py-2 bg-red-900 text-white rounded">{loading ? 'Signing in...' : 'Sign in'}</button>
        </div>
      </form>
    </div>
  );
}
